import script from "./ActionsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionsPanel.vue?vue&type=script&setup=true&lang=js"

import "./ActionsPanel.vue?vue&type=style&index=0&id=086c6237&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-086c6237"]])

export default __exports__